// filepath: /Users/bsewell/Dev/Vite2/TWR-REACT-APP/src/Components/NavTop.jsx
import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import NavTopSubMenu from './NavTopSubMenu.jsx';
import GoogleTranslate from './GoogleTranslate';
import '../App.css';

const NavTop = ({ memberID, logout }) => {
    const publicUrl = import.meta.env.VITE_PUBLIC_URL || '';

    return (
        <div>
            {/* Purple Navbar */}
            <Navbar className="navbar navbar-purple" variant="dark">
                <Container className="navbar-container">
                    {/* Brand Logo */}
                    <Navbar.Brand href="/" className="navbar-brand">
                        <img
                            src={`${publicUrl}/seiu.svg`}
                            alt="SEIU Logo"
                            className="nav-logo"
                        />
                    </Navbar.Brand>

                    {/* Web Layout: Phone Number */}
                    <a
                        href="tel:1-877-687-1021"
                        className="mrc-phone d-none d-md-block"
                        style={{ color: "white" }}
                    >
                        MRC: 1-877-687-1021
                    </a>

                    {/* Mobile Layout: Call Button */}
                    <Button
                        href="tel:1-877-687-1021"
                        variant="warning"
                        className="custom-mrc-button d-md-none"
                        style={{
                            height: "45px",
                            lineHeight: "1.1",
                            padding: "5px 10px",
                            borderRadius: "10px",
                        }}
                    >
                        Contact<br />MRC
                    </Button>

                    {/* Translation */}
                    <Nav className="ms-auto">
                        <GoogleTranslate />
                    </Nav>
                </Container>
            </Navbar>

            {/* Gray Navigation Bar */}
            <Navbar expand="md" className="navbar navbar-gray" variant="light">
                <Container className="subnav-container">
                    <NavTopSubMenu logout={logout} />
                </Container>
            </Navbar>
        </div>
    );
};

export default NavTop;